import React, { useState } from 'react';
import { API } from '../../services/api';
import './InviteMemberModal.css';

function InviteMemberModal({ organizationId, onClose, onSuccess }) {
    const [email, setEmail] = useState('');
    const [roleId, setRoleId] = useState(3); // Default: editor
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Filtrer pour ne proposer que Éditeur et Observateur lors de l'invitation
    const allRoles = API.getOrganizationRoles();
    const invitableRoles = allRoles.filter(role => role.id === 3 || role.id === 4);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!email || !email.includes('@')) {
            setError('Veuillez entrer une adresse email valide');
            return;
        }

        setLoading(true);
        try {
            await API.inviteMember(organizationId, email, roleId);
            onSuccess();
        } catch (error) {
            setError(error.message);
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content invite-member-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Inviter un membre</h2>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="email">Adresse email</label>
                        <input
                            id="email"
                            type="email"
                            className="form-input"
                            placeholder="nom@exemple.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            autoFocus
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="role">Rôle</label>
                        <select
                            id="role"
                            className="form-select"
                            value={roleId}
                            onChange={(e) => setRoleId(parseInt(e.target.value))}
                        >
                            {invitableRoles.map(role => (
                                <option key={role.id} value={role.id}>
                                    {role.label}
                                </option>
                            ))}
                        </select>
                        <div className="role-description">
                            {roleId === 3 && 'Création et modification de signatures'}
                            {roleId === 4 && 'Consultation uniquement'}
                        </div>
                        <div className="role-note" style={{ marginTop: '8px', fontSize: '12px', color: '#6b7280', fontStyle: 'italic' }}>
                            💡 Les rôles Administrateur et Propriétaire peuvent être attribués après l'invitation
                        </div>
                    </div>

                    {error && <div className="error-message">{error}</div>}

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn-secondary"
                            onClick={onClose}
                            disabled={loading}
                        >
                            Annuler
                        </button>
                        <button
                            type="submit"
                            className="btn-primary"
                            disabled={loading}
                        >
                            {loading ? 'Envoi...' : 'Envoyer l\'invitation'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default InviteMemberModal;
